/*!

 =========================================================
 * Vue Now UI Dashboard Laravel - v1.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-dashboard-laravel
 * Copyright Creative Tim (http://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)

 * Coded by www.creative-tim.com & www.invisionapp.com & www.updivision.com
 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import Vue from 'vue';
import axios from "axios";
import DashboardPlugin from './dashboard-plugin';

// Plugins
import App from './App.vue';
import VueAxios from "vue-axios";
import IsDemo from "./components/isDemo"
import VueMeta from 'vue-meta';
import VeeValidate, { Validator } from 'vee-validate'
import * as fr from 'vee-validate/dist/locale/fr'
window.$ = window.jQuery = require('jquery');
import "./assets/css/demo.css";

// Router setup
import routes from './routes';
import store from "./store";

// Dependancies
import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import { L10n, setCulture } from '@syncfusion/ej2-base';

// plugin setup
Vue.use(GridPlugin);
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: 'head' });

// Localization
setCulture('fr-FR');
L10n.load({
  'fr-FR': {
    'treegrid': {
      'Search': 'Rechercher',
      'EmptyRecord': 'Aucun enregistrement affiché',
    },

    'grid': {
      'EmptyRecord': 'Aucun enregistrement affiché',
      'GroupDropArea': 'Faites glisser un en-tête de colonne ici vers la colonne du groupe',
      'UnGroup': 'Cliquez ici pour dissocier',
      'EmptyDataSourceError': 'DataSource darf bei der Erstauslastung nicht leer sein, da Spalten aus der dataSource im AutoGenerate Spaltenraster',
      'Item': 'Elément',
      'Items': 'Eléments',
      'Search': 'Rechercher',
      'ChooseColumns': 'Choisir les colonnes',
      'Cancel': 'Retour',
      'CancelButton': 'Retour',
      'SelectAll': 'Tous séléctionner'
    },
    'pager':{
      'pagerDropDown': 'Eléments par page',
      'pagerAllDropDown': '',
      'All': 'Tous',
      'currentPageInfo': 'Page {0} sur {1}',
      'totalItemsInfo': '({0} Eléments)',
      'firstPageTooltip': 'Vers la première page',
      'lastPageTooltip': 'Vers la dernière page',
      'nextPageTooltip': 'Vers la page suivante',
      'previousPageTooltip': 'Retour à la page précédente',
      'nextPagerTooltip': 'Vers la page suivante',
      'previousPagerTooltip': 'Vers la page précédente'
    }
  }
});

// Vee-Validate Dictionnary
const dictionary = {
  fr: {
    attributes: {
      // Les champs généraux
      command_number : '\"N° de Commande\"',
      customer_command_number: '\"N° de Commande client\"',
      commercial_id: '\"Commercial\"',
      command_date: '\"Date de la commande\"',
      customer: '\"Client\"',
      final_customer: '\"Client Final\"',
      situation: '\"Situation\"',
      comment: '\"Commentaire\"',
      information: '\"Renseignement\"',
      to: '\"Destinataire\"',
      object: '\"Objet\"',
      body: '\"Corp du message\"',

      //Les champs des FNC
      num: '\"N° d\'ordre FNC\"',
      nume: '\"N° d\'Anomalie\"',
      article_name: '\"Nom d\'Article\"',
      customer_id: '\"Nom du client\"',
      received_at:'\"Date de réception\"',
      location:'\"Lieu de réception\"',
      controller:'\"Contrôlé par\"',
      quantity:'\"Quantité\"',
      importance:'\"Importance\"',
      recurence:'\"Récurrence\"',
      cause:'\"Cause\"',
      observation:'\"Obseravtion\"',
      intern_observation:'\"Observation interne\"',
      corrective_action:'\"Action correctvite immédiate\"',
      intern_corrective_action:'\"Action corrective interne\"',
      currative_action:'\"Actions curatives\"',
      solution:'\"Solution\"',
      archived_at:'\"Date de clôture\"',
      product_id:'\"Référence produit\"',
      supplier_id:'\"N° fournisseur\"',
      file_id:'\"Fichier\"',
      archived_by:'\"Clôturé par\"',
      created_by:'\"Créé par\"',
      origin:'\"origine\"',
      detected_by:'\"détectée par\"', 
      time_limit:'\"délai impératif\"',
      contact_id:'\"contact\"',
      contact_name:'\"Nom & Prénom\"',
      contact_phone:'\"N° de téléphone\"',
      contact_email:'\"Email\"',
      product_name:'\"Nom\"',
      product_reference:'\"Référence\"',

      // Les champs de "Metadata"
      '0_lecteur': '\"Renseignement\"',
      '0_type_communication': '\"Type communication\"',
      '0_firmware_m4': '\"Firmware M4\"',
      '0_techno_client': '\"Techno Client\"',
      '0_mode_m4': '\"Mode M4\"',
      '0_date_de_debut': '\"Date de début\"',
      '0_duree': '\"Durée\"',

      '1_lecteur': '\"Renseignement\"',
      '1_type_communication': '\"Type communication\"',
      '1_firmware_m4': '\"Firmware M4\"',
      '1_techno_client': '\"Techno Client\"',
      '1_mode_m4': '\"Mode M4\"',
      '1_date_de_debut': '\"Date de début\"',
      '1_duree': '\"Durée\"',

      '2_lecteur': '\"Renseignement\"',
      '2_type_communication': '\"Type communication\"',
      '2_firmware_m4': '\"Firmware M4\"',
      '2_techno_client': '\"Techno Client\"',
      '2_mode_m4': '\"Mode M4\"',
      '2_date_de_debut': '\"Date de début\"',
      '2_duree': '\"Durée\"',

      '3_lecteur': '\"Renseignement\"',
      '3_type_communication': '\"Type communication\"',
      '3_firmware_m4': '\"Firmware M4\"',
      '3_techno_client': '\"Techno Client\"',
      '3_mode_m4': '\"Mode M4\"',
      '3_date_de_debut': '\"Date de début\"',
      '3_duree': '\"Durée\"',
      // Les autres
      email: 'Email',
      name: 'nom',
      password: 'Mot de passe',
      password_confirmation: ' ',
      old_password: 'Ancien mot de passe',
      new_password: 'Nouveau mot de passe',
      repeat_password: ' ',
      phone: 'N° de télephone',
      firstname: 'Prénom',
      mainQuestion: 'question',
    }
  }
}
Validator.localize(dictionary)
Validator.localize('fr', fr)
Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  locale: 'fr',
  classes: true,
  validity: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})

window.EventBus = new Vue();

let sessionValidationPromise = null;

function validateAuthenticatedSession() {
  if (sessionValidationPromise !== null) return sessionValidationPromise;

  const checkSession = () => axios.get(process.env.VUE_APP_API_BASE_URL + 'me', {
    _skipAuthRecovery: true,
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    }
  });

  // Un 401 isolé peut survenir lors du chargement parallèle du formulaire FNC.
  // Une seconde vérification évite de supprimer une session encore valide.
  const validation = checkSession().catch(error => {
    if (error.response && error.response.status === 401) return checkSession();
    return Promise.reject(error);
  });

  sessionValidationPromise = validation.then(
    response => {
      sessionValidationPromise = null;
      return response;
    },
    error => {
      sessionValidationPromise = null;
      return Promise.reject(error);
    }
  );

  return sessionValidationPromise;
}

axios.interceptors.response.use(
    response => response,
    error => {
      const response = error.response;
      const request = error.config || {};
      const requestUrl = request.url || '';
      const isAuthenticationRequest = /\/(login|logout)(?:\?|$)/.test(requestUrl);

      if (!response || response.status !== 401 || request._skipAuthRecovery || isAuthenticationRequest) {
        return Promise.reject(error);
      }

      // La session a déjà été confirmée : ne jamais déconnecter sur le second
      // refus d'un endpoint particulier (permission ou incident localisé).
      if (request._authRetry) return Promise.reject(error);

      return validateAuthenticatedSession().then(
        () => {
          request._authRetry = true;
          return axios.request(request);
        },
        sessionError => {
          if (sessionError.response && sessionError.response.status === 401) {
            return store.dispatch("logout")
              .catch(() => undefined)
              .then(() => Promise.reject(error));
          }

          return Promise.reject(error);
        }
      );
    }
);


/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  render: h => h(App),
  router: routes,
  store:store
});

store.$app = app;

